export const AVATAR_COUNT = 20;

export function getAvatarPath(id: number): string {
  // Graceful fallback: if avatar_id is out of range (e.g. legacy 21-25), clamp to valid range
  const safeId = id >= 1 && id <= AVATAR_COUNT ? id : 1;
  return `/avatars/avatar-${String(safeId).padStart(2, '0')}.webp`;
}

// Hebrew archetype labels for each avatar
export const AVATAR_LABELS: Record<number, string> = {
  1:  'הדאנקר',
  2:  'הסנייפר',
  3:  'הפלייאמייקר',
  4:  'הביג מן',
  5:  'הוותיק',
  6:  'הרוקי',
  7:  'השואמן',
  8:  'חומת ההגנה',
  9:  'הבנצ׳ ענרגיה',
  10: 'המאמן',
  11: 'הסטילר',
  12: 'ה-3 פוינטר',
  13: 'הפוסט פלייר',
  14: 'המשחק מהר',
  15: 'הריבאונד',
  16: 'הפאסר',
  17: 'הקלאץ׳',
  18: 'המנהיג',
  19: 'הטריפל-דאבל',
  20: 'הבלוקר',
};
